import {Component, inject, signal} from '@angular/core';
import {RepoService} from "../services/repo.service";
import {DatePipe} from "@angular/common";
import {FormsModule, ReactiveFormsModule} from "@angular/forms";
import {SiteMessage} from "../models/site-message";
import {MatDialog} from "@angular/material/dialog";
import {CreateSiteMessageDrawerComponent} from "./create-site-message-drawer/create-site-message-drawer.component";
import {DeleteSiteMessageDialogComponent} from "./delete-site-message-dialog/delete-site-message-dialog.component";
import {MatRipple} from "@angular/material/core";
import {MatDrawer, MatDrawerContainer} from "@angular/material/sidenav";
import {toSignal} from "@angular/core/rxjs-interop";


@Component({
  selector: 'app-site-messages',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    FormsModule,
    DatePipe,
    MatRipple,
    MatDrawerContainer,
    MatDrawer,
    CreateSiteMessageDrawerComponent,
  ],
  templateUrl: './site-messages.component.html',
  styleUrl: './site-messages.component.css'
})
export class SiteMessagesComponent {

  dialog = inject(MatDialog);
  repoService = inject(RepoService);

  drawerIndex = signal(0);
  currentMessages = toSignal(this.repoService.listenToCurrentSiteMessage())

  onSiteClicked(siteMessage: SiteMessage) {
    this.dialog.open(DeleteSiteMessageDialogComponent, {data: siteMessage, autoFocus: false})
  }

  openCreateSiteMessageDialog(drawer: MatDrawer) {
    this.drawerIndex.set(1);
    drawer.open()
  }
}
